import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComprobanteGuard } from 'src/app/global/guards/comprobante.guards';
import { environment } from 'src/environments/environment';
import { FormUafComponent } from '../components/steppers/paso-dos/persona-juridica/declaracion-jurada/form-uaf/form-uaf.component';
import { ConfiguraProveedorServicioTecnologicoComponent } from '../components/steppers/paso-dos/shared/configura-proveedor-servicio-tecnologico/configura-proveedor-servicio-tecnologico.component';
import { AnalisisFinancieroComponent } from './analisis-financiero/analisis-financiero.component';
import { ErrorPagoComponent } from './error-pago/error-pago.component';
import { GeneracionProductoComponent } from './generacion-proceso-exito/generacion.component';
import { LayoutComponent } from './layout/layout.component';
import { ResumenCompraComponent } from './resumen-compra/resumen-compra/resumen-compra.component';
import { SpinnerReturExternalComponent } from './spinner-retur-external/spinner-retur-external.component';
import { ValidacionPagoProactivoComponent } from './validacion-pago-proactivo/validacion-pago-proactivo';



const roamingRoutes: Routes = [
  { path: '', component: LayoutComponent },
  {
    path: 'generacion-proceso', component: GeneracionProductoComponent,
    canActivate: [ComprobanteGuard]
  },
  {
    path: 'error-pago', component: ErrorPagoComponent,
    canActivate: [ComprobanteGuard]
  },
  {
    path: 'resumen-compra', component: ResumenCompraComponent,
    canActivate: [ComprobanteGuard]
  },
  {
    path: 'analisis-financiero', component: AnalisisFinancieroComponent,
    canActivate: [ComprobanteGuard]
  },
  { path: 'spinner/:origen/:codigoRespuesta', component: SpinnerReturExternalComponent },
  {
    path: 'formulario-uaf', component: FormUafComponent,
    canActivate: [ComprobanteGuard]
  },
  {path: 'validacion-pago-proactivo', component: ValidacionPagoProactivoComponent}
];

//Rutas especificas para ambientes de Prueba y desarrollo
if (!environment.production) {
  roamingRoutes.push(
    { path: 'temp', component: ConfiguraProveedorServicioTecnologicoComponent }
  )
}
@NgModule({
  imports: [RouterModule.forChild(roamingRoutes)],
  exports: [RouterModule],
  declarations: []
})

export class PagesRoutingModule { }
